import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import OrderButtonDoorDash from './OrderButtonDoorDash';
import PickupButton from './PickupButton';

const Backdrop = styled.div`
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  width: 92%; max-width: 560px;
  background: #ffffff;
  border: 1px solid #e6e6e6; border-radius: 16px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
`;

const ModalTitle = styled.h3`
  margin: 0 0 14px; color: #111; font-size: 1.25rem; text-align: center;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`;

const Actions = styled.div`
  display: flex; justify-content: space-between; margin-top: 14px;
`;

const CloseBtn = styled.button`
  background: transparent; color: #111; border: 1px solid #bbb; border-radius: 999px; padding: 8px 14px; cursor: pointer;
`;

const PrimaryBtn = styled.button`
  background: #ff761a; color: #fff; border: none; border-radius: 999px; padding: 10px 16px; font-weight: 700; cursor: pointer;
`;

const LocationItem = styled.label`
  display: flex; align-items: start; gap: 10px; padding: 10px; border: 1px solid #eee; border-radius: 10px; cursor: pointer;
`;

const Hint = styled.div`
  font-size: 0.9rem; color: #666; text-align: center; margin-top: 6px;
`;

const LOCATIONS = [
  { key: 'pleasanton', label: 'Pleasanton, CA', address: '6700 Santa Rita Rd. Ste I Pleasanton, CA 94588', pickup: true },
  { key: 'washington', label: 'Washington Ave, Houston, TX', address: '4500 Washington Ave. Ste #350 Houston, TX 77007', pickup: false },
  { key: 'heights', label: '34th St, Houston, TX', address: '1737 W. 34th St. Ste #100 Houston, TX 77018', pickup: false },
  { key: 'westheimer', label: 'Westheimer, Houston, TX', address: '11195 Westheimer Rd. Houston, TX 77042', pickup: false },
];

export default function OrderOnlineModal({ open, onClose }) {
  const [step, setStep] = useState(1);
  const [locKey, setLocKey] = useState(null);

  if (!open) return null;

  const selected = LOCATIONS.find(l => l.key === locKey);

  const onBackdrop = () => onClose?.();
  const onNext = () => { if (locKey) setStep(2); };
  const onBack = () => setStep(1);

  return (
    <Backdrop onClick={onBackdrop} aria-hidden>
      <Modal role="dialog" aria-modal="true" aria-label="Order Online" onClick={(e) => e.stopPropagation()}>
        {step === 1 && (
          <>
            <ModalTitle>Choose Your Location</ModalTitle>
            <Row>
              {LOCATIONS.map(l => (
                <LocationItem key={l.key}>
                  <input type="radio" name="loc" checked={locKey===l.key} onChange={() => setLocKey(l.key)} />
                  <div>
                    <div style={{fontWeight:700}}>{l.label}</div>
                    <div style={{fontSize:'0.95rem', color:'#444'}}>{l.address}</div>
                  </div>
                </LocationItem>
              ))}
            </Row>
            <Actions>
              <CloseBtn onClick={onClose}>Cancel</CloseBtn>
              <PrimaryBtn onClick={onNext} disabled={!locKey}>Next</PrimaryBtn>
            </Actions>
          </>
        )}

        {step === 2 && selected && (
          <>
            <ModalTitle>Order at {selected.label}</ModalTitle>
            <Row>
              {selected.pickup && (
                <Link to="/pickup" onClick={onClose} style={{textDecoration:'none'}}>
                  <div style={{display:'inline-block', padding:'14px 28px', borderRadius:999, background:'#ff761a', color:'#fff', fontFamily:'Lobster, cursive', textAlign:'center', width:'100%'}}>Pickup</div>
                </Link>
              )}
              <OrderButtonDoorDash />
            </Row>
            {!selected.pickup && (
              <Hint>Pickup not available at this location.</Hint>
            )}
            <Actions>
              <CloseBtn onClick={onBack}>Back</CloseBtn>
              <CloseBtn onClick={onClose}>Close</CloseBtn>
            </Actions>
          </>
        )}
      </Modal>
    </Backdrop>
  );
}

